import { halfAnHourInMinutes } from './constants';
import { dateTimeToDate } from './dateTimeToDate';
import { dateToDateTime } from './dateToDateTime';
import { dateTimeToISO } from './dateTimeToISO';

/**
 * @param {Date} dateTime - a dateTime object
 * @param {boolean} toISOString - whether the return value should be an ISO string
 * @returns {string | Date | null} - string or date depending on if toIsoString is true or false. Could be null if there's an error.
 */
// @ts-expect-error TS Compiler is having issues with the overload syntax here, but this should provide a good DX.
export const dateTimeRounded: DateTimeRoundedOverload = (dateTime: Date, toISOString = true) => {
  const first30Min = dateTime.getMinutes() <= halfAnHourInMinutes;
  const hours = first30Min ? dateTime.getHours() : dateTime.getHours() + 1;
  const minutes = first30Min ? halfAnHourInMinutes : 0;

  const dateWithTime = {
    ...dateToDateTime(dateTime),
    hours,
    minutes,
  };

  if (toISOString) {
    return dateTimeToISO(dateWithTime);
  }

  return dateTimeToDate(dateWithTime);
};
